import Box from '@/common/components/Box'
import { ErrorMessageWrapper } from '@/common/components/ErrorMessageWrapper'
import TextField from '@/common/components/TextField'
import { EquipmentModelData } from '@/features/equipmentModels/types/equipmentModels'

interface GeneralDataTabProps {
  equipment: EquipmentModelData | undefined
  isLoading: boolean
  requestError: { status?: number }
  refetchRequest: () => void
}

const GeneralDataTab = ({ equipment, isLoading, requestError, refetchRequest }: GeneralDataTabProps) => {
  if (isLoading) {
    return <Box>Carregando...</Box>
  }

  return (
    <ErrorMessageWrapper
      className="max-h-[calc(100vh-128px)]"
      statusCode={requestError?.status}
      refetchFunction={refetchRequest}
    >
      <Box className="flex flex-col gap-4 shadow-[4px_4px_8px_4px_rgba(0,_0,_0,_0.2)]">
        <p className="text-lg font-bold">{equipment?.display_name}</p>

        {equipment?.fipe_code && (
          <div>
            <p className="text-[14px] italic font-light">Código FIPE</p>
            <p className="font-bold">{equipment?.fipe_code}</p>
          </div>
        )}

        <div className="flex gap-2">
          <TextField
            label="Categoria"
            disabled
            data-testid="category_id_selector"
            className="w-1/2"
            value={equipment?.category.display_name}
          />
          <TextField label="Ano" disabled data-testid="year_input" className="w-1/2" value={`${equipment?.year}`} />
        </div>

        <div className="flex gap-2">
          <TextField label="Marca" disabled data-testid="brand_input" className="w-1/2" value={equipment?.brand} />
          <TextField
            label="Modelo"
            disabled
            data-testid="display_name_input"
            className="w-1/2"
            value={equipment?.display_name}
          />
        </div>

        <TextField
          label="Porte"
          disabled
          data-testid="equipment_tier_input"
          value={equipment?.equipment_tier?.display_name || ''}
        />

        <TextField
          label="Produtos e serviços aplicáveis"
          disabled
          data-testid="applicable_product_ids_selector"
          value={equipment?.applicable_products.map((product) => product.display_name).join(', ')}
        />
      </Box>
    </ErrorMessageWrapper>
  )
}

export default GeneralDataTab
